import { toast } from 'react-toastify';
import { AxiosError } from 'axios';

import useSyncMutation from './useSyncMutation';

import { useLanguageContext } from '~providers';
import { delRequest } from '~services';
import { DeletePaymentMethodRequest, MutateContext } from '~types';

export const useMutationDeletePaymentMethod = ({
  shouldToast = true,
  onErrorCallback,
}: MutateContext & { onErrorCallback?: (errorMsg: string) => void }) => {
  const { lt } = useLanguageContext();

  return useSyncMutation(
    ({ id, gateway }: DeletePaymentMethodRequest) => {
      return delRequest({
        path: `api/payment/payment-method/${id}`,
        params: gateway ? { gateway } : undefined,
      });
    },
    {
      onError(error) {
        const fallback = lt(
          'text.hooks.useMutationDeletePaymentMethod.error',
          'Something went wrong when deleting payment method',
        );
        const message =
          error instanceof AxiosError
            ? error.response?.data?.message ?? fallback
            : fallback;

        if (shouldToast) toast.error(message);
        onErrorCallback?.(message);
      },
      onSuccess() {
        if (shouldToast) {
          toast.success(
            lt(
              'text.hooks.useMutationDeletePaymentMethod.success',
              'Deleted payment method successfully',
            ),
          );
        }
      },
    },
  );
};
